import { Dot, Drawer, Icon } from "components";
import { types } from "constant";
import { MagazineType } from "enums";
import { isEqual } from "lodash";
import { Dispatch } from "react";
import { ToggleProps } from "types";

type Props = ToggleProps & {
  activeType: MagazineType[] | null;
  onSelect: Dispatch<MagazineType[] | null>;
};

export default function SelectMagazineTypeDrawer({
  isOpen,
  toggle,
  activeType,
  onSelect,
}: Props) {
  const handleSelect = (e: MagazineType[] | null) => {
    return () => {
      onSelect(e);
      toggle?.();
    };
  };
  return (
    <Drawer isOpen={isOpen} toggle={toggle}>
      <Drawer.Menu>
        <Drawer.Body>
          <ul className="w-full">
            {types.magazine.map((e) => {
              const active = isEqual(e.id, activeType);
              return (
                <li
                  key={e.name}
                  className="cursor-pointer space-y-1"
                  onClick={handleSelect(e.id)}
                >
                  <div className="w-full flex items-center gap-2.5">
                    <div className="size-8 flex justify-center items-center">
                      <Icon
                        name={e.icon}
                        variant="Bold"
                        className="size-6 text-primary"
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="block w-full truncate text-base text-[#353740] font-medium">
                        {e.name}
                      </h3>
                    </div>
                    {active && <Dot />}
                  </div>
                  <div className="w-full h-2.5 flex items-center justify-end">
                    <hr className="border-[#ECEFF2] w-[90%]" />
                  </div>
                </li>
              );
            })}
          </ul>
        </Drawer.Body>
      </Drawer.Menu>
    </Drawer>
  );
}
